export default class types {
	static APP = 'APP';

	static SET_ACTIVE_PAGE = `${types.APP}/SET_ACTIVE_PAGE`;

	static SET_LANGUAGE = `${types.APP}/SET_LANGUAGE`;
}
